// src/api/documents.js
import { requestJson, getAuthToken, getApiBaseUrl } from './http';

// List documents for any entity
export function getDocuments(entityType, entityId) {
  const params = new URLSearchParams({
    entity_type: entityType,
    entity_id: entityId,
  });
  return requestJson(`/documents?${params.toString()}`);
}

// Upload a document (e.g. for driver, vehicle, hire_agreement)
export async function uploadDocument(formData) {
  return requestJson("/documents/upload", {
    method: "POST",
    body: formData,
  });
}

// Delete a document
export async function deleteDocument(documentId) {
  await requestJson(`/documents/${documentId}`, {
    method: 'DELETE',
    expectJson: false,
  });
}

// Get download URL for a document (use in href or window.location)
export function downloadDocumentUrl(documentId) {
  return `${getApiBaseUrl()}/documents/download/${documentId}?authorization=Bearer%20${getAuthToken()}`;
}

// Convenience: immediately trigger a browser download
export function downloadDocument(documentId) {
  window.location.href = downloadDocumentUrl(documentId);
}
